import { YearOption } from "../types";

export { SELECTED_YEAR_BUTTON_SX } from '../../../styles/datePickerStyles';

/** Last allowed FY is 2036-37; creation beyond this (start year >= 2037) is not allowed. */
export const MAX_FY_START_YEAR = 2036;

export const FINANCIAL_YEAR_OPTIONS: YearOption[] = [
  { option: '01 Jan - 31 Dec', value: 'CALENDAR' },
  { option: '01 Apr - 31 Mar', value: 'FINANCIAL' },
];